import React from 'react';
import Thead from './thead';
import Tbody from './tbody';

import { isEmpty } from 'lodash/lang';

/**
 * @visibleName Table 表单
 */
class Base extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  getBodyColgroup = () => {
    const { columns = [], selector } = this.props;
    const cols = columns.map((col, i) => <col key={i} style={{ width: col.width || undefined }} />);
    return (
      <colgroup>
        {!isEmpty(selector) && <col style={{ width: selector.width }}></col>}
        {cols}
      </colgroup>
    );
  };

  render() {
    const { props } = this;

    return (
      <table>
        {this.getBodyColgroup()}
        <Thead {...props} />
        <Tbody {...props} />
      </table>
    );
  }
}

export default Base;
